/* eslint-disable no-nested-ternary */
import React, { useState } from "react";
import PopupLayer from "../common/PopupLayer";
import { getPopupURL } from "../../../app/Helper/CommonHelper";

/**
 * 환불규정(투어/컬쳐딜) 컴포넌트
 */
function RefundInfo() {
  const [isLayerOpen, setIsLayerOpen] = useState(false);
  const {
    bIsDeliveryDeal,
    htDealContentInfo: {
      bannerViewInfo,
      bannerViewInfo: { hideUnusedRefundRate },
      contentInfo: { refundRule },
    },
    htDealInfo: { dealPackNoList },
    bIsLocalDeal,
    bIsTourDeal,
  } = TMON.oApp.htStorage.htStaticData;
  const layerOptions = {
    hideUnusedRefundRate,
    bIsLocalDeal,
    bIsTourDeal,
    refundRule,
  };

  const handleLayerOpen = () => {
    if (TMON.oApp.sPlatform === "MA") {
      // refundRule data가 길게 들어가 서버에서 정보 내려 받음
      // data parameter 개선을 위해 localstorage 사용
      layerOptions.refundRule = "";
      localStorage.setItem(
        "deal_popup_data",
        JSON.stringify({
          ...layerOptions,
          dealSrls: String(TMON.htStaticData.htDealInfo.dealNo),
        })
      );
      TMON.app.callApp(
        "webview",
        "showView",
        "환불규정",
        getPopupURL("refund"),
        true
      );
    } else {
      setIsLayerOpen(true);
    }
  };

  const handleLayerClose = () => {
    setIsLayerOpen(false);
  };
  
  return (
    !bIsDeliveryDeal &&
    bannerViewInfo &&
    !bannerViewInfo.hideUnusedRefundInfo &&
    (hideUnusedRefundRate || hideUnusedRefundRate === 0) && (
      <div className="deal_info_unit">
        <div className="info_unit_title">
          <h3 className="title">환불규정</h3>
        </div>
        <div className="info_unit_contents">
          {dealPackNoList.includes(80022)
            ? <p>판매기간 내 환불 가능</p>
            : (
                <div
                className="info_unit_button"
                role="button"
                onClick={handleLayerOpen}
                >
                  <p>
                    {hideUnusedRefundRate === 0 
                      ? "미사용 티켓 환불제 미적용 상품" 
                      : `미사용티켓 ${hideUnusedRefundRate}% 티몬캐시·적립금 환불`
                    }
                  </p>
                </div>
              )
          }

          {/* 팝업 레이어 */}
          {isLayerOpen && (
            <PopupLayer
              title="환불규정"
              onClose={handleLayerClose}
              popupKey="refund"
              layerOptions={{
                hideUnusedRefundRate,
                bIsLocalDeal,
                bIsTourDeal,
                refundRule,
              }}
            />
          )}
        </div>
      </div>
    )
  );
}

export default RefundInfo;
